module.exports = __webpack_public_path__ + "static/media/logo_4.65b60f63.png";